<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="商品搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加砍价商品</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="砍价商品">
          </el-table-column>
          <el-table-column
            align="center"
            prop="thumb"
            label="商品图片">
            <template slot-scope="scope">
              <el-image
                class="mt-table-goods-img"
                :src="scope.row.thumb == null ? imgServer+'no_img.png' : scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsSpecPrice"
            label="商品价格">
          </el-table-column>
          <el-table-column
            align="center"
            prop="lowestMoneyBargain"
            label="最低价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockNum"
            label="库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activityStartTime"
            label="活动时间">
            <template slot-scope="scope">
              <span>{{scope.row.activityStartTime+'-'+scope.row.activityEndTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { queryBargainGoodsPageList, removeBargainGoodsById  } from '@/api/bargainActivity'
export default {
  name: 'BargainActivity',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryBargainGoodsPageList({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/bargain_goods_add', query: {dataId: infoId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeBargainGoodsById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/bargainActivity/BargainActivity.vue